// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1qQAo","title":"AfterFrontImage_title__18qEv"};